import { MISSION_ALPHA, MISSION_GAMMA, SHOW_DRIVE_BUTTON, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    missionAlpha: false,
    openGamma: false,
    showDriveBtn: false
}

export const missionAlphaReducer = (state = initialState, action) => {
    switch (action.type) {
        case MISSION_ALPHA:
            return {
                ...state,
                missionAlpha: action.payload
            };
        case MISSION_GAMMA:
            return {
                ...state,
                openGamma: action.payload
            };
        case SHOW_DRIVE_BUTTON:
            return {
                ...state,
                showDriveBtn: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}